import React from 'react';
import PropTypes from 'prop-types';

import { Show } from '../../../show';

import MathContent from '../../../math-content';
import Stack from '../../../stack';

import { CORRECT, MISSING, INCOMPLETE } from '../../../../lib/exercise';
import { getExecutionCorrection } from '../../../../lib/checker';

export const LABELS = {
    [CORRECT]: 'Svolgimento esatto.',
    [MISSING]: 'Svolgimento mancante.',
    [INCOMPLETE]: 'Svolgimento incompleto.',
};

const StepsFeeedback = ({ exercise, correctionStatus, steps }) => {
    const correctionStatusState = (correctionStatus && correctionStatus.state) || correctionStatus?.status;

    const executionCorrection = getExecutionCorrection(steps);

    return (
        <>
            <strong>{LABELS[correctionStatusState]}</strong>

            <Show when={executionCorrection !== CORRECT || correctionStatusState !== CORRECT}>
                <Stack gap="xs" direction="horizontal">
                    <strong>{'La soluzione esatta è:'}</strong>
                    <MathContent>{exercise.answerContent}</MathContent>
                </Stack>
            </Show>
        </>
    );
};

StepsFeeedback.propTypes = {
    exercise: PropTypes.object,
    correctionStatus: PropTypes.object,
    steps: PropTypes.array,
};

export default StepsFeeedback;
